import { CalendarToday } from '@mui/icons-material';
import {
  Button,
  Card,
  Divider,
  IconButton,
  Skeleton,
  SvgIcon,
  Switch,
  SwitchProps,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { Box, Stack, styled } from '@mui/system';
import Grid from '@mui/system/Unstable_Grid/Grid';
import moment from 'moment';
import { ChangeEvent, FC, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BasicDateCalendar } from 'src/layouts/components/CustomDatePicker';
import {
  getUnlockTherapistAction,
  resetUpdateTherapistUnlock,
  updateUnlockTherapistAction,
} from 'src/redux/actions/unlockTherapistAction';
import SimpleSnackbar from '../sub-components/snackBar';
import UnlockTherapistTable from './unloack-therapist-table';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  onCloseUnlock: any;
};

const discipleTap = [
  { displayName: 'PT', key: 'PT', count: 0 },
  { displayName: 'OT', key: 'OT', count: 0 },
  { displayName: 'SLP', key: 'SLP', count: 1 },
];

interface IOSSwitchProps extends SwitchProps {}

// @ts-ignore
export const IOSSwitch: FC<IOSSwitchProps> = styled((props: IOSSwitchProps) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#6366F1',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#E0E0E0',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: 'background-color 500ms',
  },
});
const UnlockTherapist = (props: Props) => {
  const { onCloseUnlock } = props;
  const dispatch = useDispatch();
  const [openCalender, setOpenCalender] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const calenderRef = useRef<HTMLDivElement | null>(null);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const getAllUnlockTherapist = useSelector((state: any) => state?.getUnlockTherapistReducer);
  const updateUnlockRes = useSelector((state: any) => state?.updateUnlockTherapistReducer);
  const [discipline] = useCurrentUser(['discipline']);
  const handleClickCalender = () => {
    setOpenCalender((prev: any) => !prev);
  };
  const jsDate = moment(selectedDate, 'DD-MM-YYYY').toDate();
  const formattedDate = moment(jsDate).format('MMM D, YYYY');
  const currentDate = moment();
  const handleChangeDate = (e: any) => {
    setSelectedDate(new Date(e));
    setOpenCalender(false);
  };
  const [currentTab, setCurrentTab] = useState<string>('PT');
  const [unlockData, setUnlockData] = useState([]);
  const [forOther, setForOther] = useState(false);

  useEffect(() => {
    if (getAllUnlockTherapist?.isGetUnlock && getAllUnlockTherapist?.response !== null) {
      if (!!getAllUnlockTherapist?.response?.data?.documents?.length) {
        setForOther(getAllUnlockTherapist?.response?.data?.otherPatient);
        return setUnlockData(getAllUnlockTherapist?.response?.data?.documents);
      }
      setUnlockData(getAllUnlockTherapist?.response?.data?.documents);
      setForOther(getAllUnlockTherapist?.response?.data?.otherPatient);
    } else {
      setUnlockData([]);
    }
  }, [getAllUnlockTherapist]);

  const handleTabsChange = useCallback((event: ChangeEvent<any>, value: string): void => {
    // abortControllerRef.current.abort();
    // abortControllerPatinetListRef.current.abort();
    setCurrentTab(value);
  }, []);
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (!updateUnlockRes?.isUpdatedUnlock && updateUnlockRes?.isUpdatedUnlock === null) return;
    if (!updateUnlockRes?.isUpdatedUnlock && updateUnlockRes?.isUpdatedUnlock !== null) {
      setMessage(updateUnlockRes?.response?.message);
      setTimeout(() => {
        setMessage('');
        dispatch(resetUpdateTherapistUnlock());
      }, 3500);
      return;
    }
  }, [updateUnlockRes]);

  useEffect(() => {
    if (!!patientData?.uuid) {
      dispatch(
        getUnlockTherapistAction({
          discipline: currentTab,
          localDate: moment(selectedDate).format('YYYY-MM-DD'),
          patientId: patientData?.uuid,
        })
      );
    }
  }, [currentTab, selectedDate]);

  const handleChangeSwitch = (e: any, res: any) => {
    setUnlockData((prevEvents: any) => {
      return prevEvents.map((event: any) => {
        if (event?.uuid === res?.uuid) {
          return {
            ...event,
            locked: e.target.checked,
          };
        }
        return event;
      });
    });
  };

  const handleChangeForOther = (e: any) => {
    setForOther(e.target.checked);
  };

  const handleSaveUnlockData = () => {
    const unlockPayload =
      unlockData?.map((res: any) => {
        return {
          uuid: res?.uuid,
          lock: res?.locked,
        };
      }) ?? [];
    dispatch(
      updateUnlockTherapistAction({
        data: unlockPayload,
        param: {
          onOff: forOther,
          localDate: moment(selectedDate).format('YYYY-MM-DD'),
          patientId: patientData?.uuid,
          discipline,
        },
      })
    );
  };

  return (
    <Grid
      flexDirection={'column'}
      justifyContent={'space-between'}
      container
      sx={{ height: '100%' }}
    >
      <>
        <Grid xs={12}>
          <Grid
            container
            sx={{ width: '100%' }}
          >
            <Grid
              py={2}
              px={2}
              xs={12}
              sx={{ width: '100%' }}
            >
              {' '}
              <Stack
                direction="row"
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="h6">Unlock Overdue Documents</Typography>
                  <Stack ref={calenderRef}>
                    <Button
                      sx={{
                        background: '#fff',
                        borderRadius: '12px',
                        border: '1px solid rgba(17, 25, 39, 0.16)',
                        color: '#384250',
                        '&:hover': {
                          border: '1px solid rgba(17, 25, 39, 0.16)',
                        },
                      }}
                      size="small"
                      startIcon={
                        <SvgIcon>
                          <CalendarToday />
                        </SvgIcon>
                      }
                      variant="outlined"
                      onClick={handleClickCalender}
                    >
                      {formattedDate} {moment(jsDate).isSame(currentDate, 'day') && '(Today)'}
                    </Button>
                    {openCalender && (
                      <BasicDateCalendar
                        value={selectedDate}
                        handleChangeDate={handleChangeDate}
                      />
                    )}
                  </Stack>
                </Box>
                <IconButton onClick={onCloseUnlock}>x</IconButton>
              </Stack>
              <Stack mt={5}>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={4}
                  sx={{ width: '100%' }}
                >
                  <Card sx={{ width: '100%', p: 2 }}>
                    <Tabs
                      indicatorColor="primary"
                      onChange={handleTabsChange}
                      scrollButtons="auto"
                      textColor="primary"
                      value={currentTab}
                      variant="scrollable"
                    >
                      {discipleTap?.map((tab: any) => (
                        <Tab
                          key={tab.key}
                          label={
                            <span>
                              <span>{tab.key}</span>
                            </span>
                          }
                          value={tab.key}
                        />
                      ))}
                    </Tabs>
                    <Divider />
                    <Card>
                      <Box
                        sx={{ border: '1px solid #F2F4F7', borderRadius: '20px' }}
                        p={3}
                      >
                        <UnlockTherapistTable
                          item={unlockData}
                          handleChangeSwitch={handleChangeSwitch}
                        />
                      </Box>
                    </Card>
                  </Card>
                </Stack>
              </Stack>
              <Stack
                py={2}
                flexDirection={'row'}
                alignItems={'center'}
                gap={1}
                pl={3}
              >
                {getAllUnlockTherapist?.loading ? (
                  <Typography
                    width={'20%'}
                    ml={3}
                    variant="h4"
                  >
                    <Skeleton animation={false} />
                  </Typography>
                ) : (
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography
                        variant="body1"
                        sx={{ color: '#111927' }}
                      >
                        Open For All
                      </Typography>
                      <IOSSwitch
                        checked={forOther}
                        onChange={handleChangeForOther}
                      />
                      {forOther ? 'Locked' : 'Unlocked'}
                    </Box>
                    <Typography
                      sx={{ mt: 2, color: '#6C737F' }}
                      variant="body2"
                    >
                      Note: Toggle to lock/unlock Other patients documents across all therapists for
                      selected date
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          xs={12}
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
            px: 1,
            py: 1,
          }}
        >
          <Button
            sx={{ width: 300 }}
            variant="outlined"
            onClick={onCloseUnlock}
          >
            Cancel
          </Button>
          <Button
            sx={{ width: 300 }}
            variant="contained"
            onClick={handleSaveUnlockData}
            disabled={updateUnlockRes?.loading}
          >
            Save
          </Button>
        </Grid>
        {message !== '' && updateUnlockRes?.response !== null && (
          <SimpleSnackbar
            message={message}
            isError={updateUnlockRes?.isUpdatedUnlock}
          />
        )}
      </>
    </Grid>
  );
};

export default UnlockTherapist;
